<template>
  <b-container id="maindiv">

    <section>
      <b-row>
        <div class="col-md-8">
          <h2>{{$lang('aproposals')}}</h2>
          <p class="my-3">{{$lang('description')}}</p>
        </div>
        <div class="col-md-4">
          <div class="toolbar">
            <button class="btn btn-primary shadow-sm mt-2" @click="addProposal()">{{$lang('aproposalNew')}}</button>
          </div>
        </div>
      </b-row>
    </section>

    <section id="mainsection">
      <div id="content">
        <b-table striped hover head-variant="dark" primary-key="id" :items="aproposalsList" stacked="md" :fields="aproposalsFields" :current-page="currentPage" :per-page="perPage" :busy="wait">
          <template slot="s_s" slot-scope="row">
            <a :href="'/#/aproposal/'+row.item.id">
              <div class="state">
                <i class="fa fa-circle-o mr-1" v-bind:style="{'color': row.item.s_sclr}"></i>{{row.item.s_s}}
              </div>
            </a>
          </template>   
          <div slot="table-busy" class="text-center text-muted my-5">
             <b-spinner class="align-middle"></b-spinner>
             <strong>Loading...</strong>
          </div>          
        </b-table>
        <b-row>
          <b-col md="6" class="my-4">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>        
      </div>
    </section>

    <b-modal v-bind:busy="form.wait" no-close-on-backdrop id="modal-1" :title="$lang('aproposalNew')" @ok.prevent="handleOk" :ok-title="$lang('apply')" :cancel-title="$lang('cancel')">
      <AproposalItem v-bind:item=form></AproposalItem>
    </b-modal>

    <section>
    </section>
    
  </b-container>
</template>


<script>
import axios from 'axios';
import AproposalItem from "./AproposalItem.vue";
export default {
  created() {
    this.fetchList()
  },
  data() {
    return {
      form: {
        id: -1,
        vacationtype: 10,
        dbeg: new Date().toISOString().substring(0,10),
        dend: null,
        shortstart: null,
        shortduration: null,
        periodtype: 1,
        remark: '',
        wait: null,
        // file: File,
        imagedata: null,
        error: null,
        emcase: null,
        emcaseother: null,
        emcaseconfirm: null,
      },
      aproposalsList: [],
      aproposalsFields: [
        {key: "s_s", label: this.$lang("state" )},
        {key: "vacationtype", label: this.$lang("atype"), sortable: true},
        {key: "dbeg", label: this.$lang("date"), sortable: true},
        {key: "dend", label: this.$lang("todate"), sortable: true},
        {key: "periodtype", label:this.$lang("ptype"), sortable: true},
        {key: "shortstart", label:this.$lang("sabegin"), sortable: true},
        {key: "shortduration", label:this.$lang("saduration"), sortable: true},
        {key: "remark", label:this.$lang("remark")},
      ],
      totalRows: 30,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      wait: true,      
    };
  },
  components: { AproposalItem },
  methods: {
    addProposal() {
      this.form.wait = null;
      this.form.error = null;
      this.$bvModal.show("modal-1");
    },
    fetchList() {
       axios.get("/api/GetAbsencesList")
         .then(resp => {
           this.aproposalsList = resp.data;
           this.totalRows = this.aproposalsList.length;
           this.wait = null;
         }).catch(err => {
           if (err.response.status == 401)
              this.$router.push('/')
         })
    },
    async handleOk(evt) {
      this.form.wait = true;
      this.form.error = null;
      let form = evt.vueTarget.$refs.body.firstChild
      if (!form.checkValidity()){
         form.classList.add('was-validated');
         this.form.wait = null
         return;
      }
      var isemcase = [30, 10, 15, 70].includes(this.form.vacationtype);
      var data2save = {
        vacationtype: this.form.vacationtype,
        dbeg: this.form.dbeg,
        dend: this.form.dend,
        shortstart: this.form.shortstart,
        shortduration: this.form.shortduration,
        periodtype: this.form.periodtype,
        remark: this.form.remark,
        imagedata: this.form.imagedata, 
        emcase: isemcase&&this.form.emcaseconfirm?this.form.emcase:null,
        emcaseother: isemcase&&this.form.emcaseconfirm?this.form.emcaseother:null,
        emcaseconfirm: isemcase?this.form.emcaseconfirm:null,
        specialleavetype: this.form.specialtype,
        specialleaveshort: this.form.specialShort,
      }
      if (data2save.vacationtype == 20 && data2save.imagedata == null && data2save.dend != null && ((new Date(data2save.dend) - new Date(data2save.dbeg)) / (1000 * 60 * 60 * 24)) > 2) {
        this.form.wait = false;
        this.form.error = null;
        this.$bvModal.msgBoxConfirm(this.$lang("noSert"), {okTitle: this.$lang("yes"),cancelTitle: this.$lang("no")})
          .then(value => {
            if (value) {
              this.doSaveProposal(data2save);
            }
          })
      } else {
        this.doSaveProposal(data2save);
      }
    },
    async doSaveProposal(data2save){
      this.form.wait = true;
      axios.post('/api/AddAbsenceProposal', data2save) 
        .then(answ => {
          this.$bvModal.hide("modal-1");
          this.$bvToast.toast(answ.data.message, {title: "Document saved", variant: "success"});
          this.fetchList();
        })
        .catch(error => {
          this.form.wait = null;
          this.form.error = error.message;
          if (error.response.data.message) {
             this.form.error = error.response.data.message;
          }
        });
    }

  },
  locales: {
    en: {
        aproposals: "Absence Proposals",
        aproposalNew: "New Absence Proposal",
        state: "State",
        atype: "Absence Type",
        date: "Date",
        todate: "Until Date",
        ptype: "Period Type",
        sabegin: "Short Absence Begin",
        saduration: "Short Absence Duration",
        remark: "Remark",
        description: "To submit an application for absence, you must select the type of absence and fill out the form fields. After filling out the form, please confirm your absence proposal with the 'Apply' button.",
        apply: "Apply",
        cancel: "Cancel",
        noSert: "You haven’t uploaded your sickness certificate. Are you sure you want to proceed without uploading?",
        yes: "Yes",
        no: "No",
      },
    de: {
        aproposals: "Abwesenheitsanträge",
        aproposalNew: "Neuer Abwesenheitsantrag",
        state: "Zustand",
        atype: "Abwesenheitsart",
        date: "Datum",
        todate: "Bis zum Datum",
        ptype: "Periodentyp",
        sabegin: "Kurze Abwesenheit ab",
        saduration: "Kurze Abwesenheitsdauer",
        remark: "Bemerkungen",
        description: "Um einen Abwesenheitsantrag zu stellen, müssen Sie die Art der Abwesenheit auswählen und die vorgegebenen Formularfelder ausfüllen. Nachdem Sie das Formular ausgefüllt haben, bestätigen Sie den Antrag mit der Schaltfläche 'Beantragen'.",
        apply: "Beantragen",
        cancel: "Abbrechen",
        noSert: "Sie haben Ihren Arbeitsunfähigkeitsbescheinigung nicht hochgeladen. Sind Sie sicher, dass Sie ohne Hochladen fortfahren möchten?",
        yes: "Ja",
        no: "Nein",
    },
    ru: {
        aproposals: "Записи об отсутствии",
        aproposalNew: "Новая запись об отсутствии",
        state: "Состояние",
        atype: "Вид отсутствия",
        date: "Дата",
        todate: "До даты",
        ptype: "Период",
        sabegin: "Короткое отсуствие с",
        saduration: "Длительность короткого отсутствия",
        remark: "Примечания", 
        description: "Для подачи заявления на отсутствие нужно выбрать тип отсутствия и заполнить предложенные поля формы. После заполнения формы, пожалуйста подтвердите заявление кнопкой 'На утверждение'.",
        apply: "На утверждение",
        cancel: "Отмена",
        noSert: "Вы не прикрепили изображение больничного листа к заявке. Вы уверены что хотите подать заявку без изображения больничного листа?",
        yes: "Да",
        no: "Нет",
    },
    pl: {
        aproposals: "Rejestry nieobecności",
        aproposalNew: "Nowy rekord nieobecności",
        state: "Stan",
        atype: "Typ",
        date: "Data",
        todate: "Aktualny",
        ptype: "Okres nieobecności",
        sabegin: "Godzina rozpoczęcia nieobecności",
        saduration: "Długość nieobecności",
        remark: "Uwagi", 
        description: "Aby zgłosić nieobecność należy wybrać rodzaj nieobecności i wypełnić proponowane pola formularza. Po wypełnieniu formularza prosimy o potwierdzenie złożenia wniosku przyciskiem „Prześlij do zatwierdzenia”.",
        apply: "Prześlij do zatwierdzenia",
        cancel: "Anulować",
        noSert: "Do wniosku nie załączyłeś zdjęcia zwolnienia lekarskiego. Czy na pewno chcesz złożyć wniosek bez zdjęcia zwolnienia lekarskiego?",
        yes: "Tak",
        no: "Nie",
    }  
  }
};
</script>

<style>

.toolbar {
  padding: 0 0 30px 0;
  display: flex;
  justify-content: flex-end;
}

.state {
  white-space: nowrap;
} 

</style>


// WEBPACK FOOTER //
// src/Aproposals.vue